import { render, staticRenderFns } from "./ModalDeleteForm.vue?vue&type=template&id=4933a881&"
import script from "./ModalDeleteForm.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports